import { render, staticRenderFns } from "./FullContent.vue?vue&type=template&id=71db0412&scoped=true&"
var script = {}
import style0 from "./FullContent.vue?vue&type=style&index=0&id=71db0412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db0412",
  null
  
)

export default component.exports